var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/DTAInformationDialog',["require", "exports", "common/viewmodelbase", "plugins/dialog", "models/portal"], function (require, exports, common, dialog, Portal) {
    "use strict";
    var DTAInformationViewModel = (function (_super) {
        __extends(DTAInformationViewModel, _super);
        function DTAInformationViewModel() {
            _super.call(this);
        }
        DTAInformationViewModel.prototype.onActivated = function (context) {
            this.dontShow = false;
        };
        // #endregion ctor
        DTAInformationViewModel.prototype.closeDialog = function () {
            var userManager = Portal.Context.shell.userManager;
            userManager.saveSettings("showDTA", { 'ShowDTA': !this.dontShow });
            dialog.close(this);
        };
        return DTAInformationViewModel;
    }(common.ListViewModelBase));
    var instance = new DTAInformationViewModel();
    return instance;
});

